import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const CheckCircle = ({
  width = 32,
  height = 32,
  className,
  color,
  decorative = false,
  ariaLabel = "Check circle",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29 28"
      fill="none"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5556 27.3337C6.88493 27.3337 0.666664 21.3641 0.666664 14.0003C0.666664 6.63653 6.88493 0.666992 14.5556 0.666992C18.2391 0.666992 21.7718 2.07175 24.3765 4.57224C26.9812 7.07272 28.4444 10.4641 28.4444 14.0003C28.4444 21.3641 22.2262 27.3337 14.5556 27.3337ZM21.6388 8.53366L22.6111 9.46699L11.7777 19.6003L5.24995 13.467L6.22217 12.5337L11.7777 17.7337L21.6388 8.53366ZM14.5556 2.00033C21.4591 2.00033 27.0556 7.37291 27.0556 14.0003C27.0556 20.6277 21.4591 26.0003 14.5556 26.0003C7.65199 26.0003 2.05555 20.6277 2.05555 14.0003C2.05555 7.37291 7.65199 2.00033 14.5556 2.00033Z"
        fill="#008055"
      />
    </svg>
  );
};


